/*
 * des 特色资源push稿快速预览
 * date 2018-01-17
 * author lileilei
 */
'use strict';
angular.module('toutiaoQuickPreview', ['toutiaoPrevDetailModule'])
    .controller('toutiaoQuickPreviewCtrl', ['$scope', 'storageListenerService', '$state', '$stateParams', '$timeout', 'trsHttpService', 'localStorageService', '$q', 'trsspliceString', '$filter', '$compile', 'resCtrModalService', 'globleParamsSet',
        function($scope, storageListenerService, $state, $stateParams, $timeout, trsHttpService, localStorageService, $q, trsspliceString, $filter, $compile, resCtrModalService, globleParamsSet) {
            initStatus();
            initData();
            /**
             * [initStatus description] 状态初始化
             */
            function initStatus() {
                //初始化分页参数
                $scope.page = {
                    "CURRPAGE": 1,
                    "ITEMCOUNT": "",
                    "PAGECOUNT": "",
                    "PAGESIZE": 20,
                };
                $scope.jumpToPageNum = 1;
                //请求列表的参数,有一些写死的参数
                $scope.params = {
                    typeid: "zyzx",
                    serviceid: "toutiao",
                    modelid: "findFromNavigation",
                    pageSize: $scope.page.PAGESIZE,
                    pageNum: "1",
                    media_id: $stateParams.nodeid,
                    keyword: {
                        keywords: "",
                        title: "",
                        content: "",
                        menuscriptType: '',
                        searchType: '0'
                    }
                };
                $scope.data = {
                    items: [],
                    selectedArray: [],
                    operFlags: []
                };
                $scope.status = {
                    batchOperateBtn: {
                        "hoverStatus": ""
                    },
                    searchShow: false, //是否显示搜索栏
                    showRightDetail: true, //是否显示右侧详情
                    curSelected: "" //当前选中的详情ID
                };
            }
            /**
             * [initDropDown description] 初始化搜索下拉框
             * @return {[type]} [description]
             */
            function initDropDown() {
                $scope.data.filterTypes = [{
                    name: "全部",
                    value: '0'
                }, {
                    name: "标题",
                    value: "1"
                }, {
                    name: "正文",
                    value: "2"
                }];
                $scope.data.filterTypeSelected = angular.copy($scope.data.filterTypes[0]);
                $scope.data.docType = [{
                    name: '全部稿件',
                    value: '0'
                }, {
                    name: '文字',
                    value: '1'
                }, {
                    name: '图片',
                    value: '2'
                }];
                $scope.data.docTypeSelected = angular.copy($scope.data.docType[0]);
            }

            /**
             * [initData description] 数据初始化
             */
            function initData() {
                listenStorage();
                initDropDown();
                listenStorage();
                if (angular.isDefined($scope.$root.filterData)) { //判断是否有传递的数据
                    // $timeout(function() {
                    $scope.page = $scope.$root.filterData.page;
                    $scope.params.page = $scope.page.CURRPAGE;
                    $scope.params.pageSize = $scope.page.PAGESIZE;
                    $scope.params.keyword = $scope.$root.filterData.keyword;
                    $scope.params.keyword.title = $scope.$root.filterData.keyword.title;
                    $scope.params.keyword.content = $scope.$root.filterData.keyword.content;
                    if (!!$scope.params.keyword.keywords) { //当前检索词
                        $scope.status.searchShow = true;
                        if ($scope.$root.filterData.filterSelected.value == '0') {
                            $scope.data.filterTypeSelected = angular.copy($scope.data.filterTypes[0]);
                        } else if ($scope.$root.filterData.filterSelected.value == '1') {
                            $scope.data.filterTypeSelected = angular.copy($scope.data.filterTypes[1]);
                        } else {
                            $scope.data.filterTypeSelected = angular.copy($scope.data.filterTypes[2]);
                        }
                    }
                    //设置日期
                    $scope.data.date = angular.copy(angular.isDefined($scope.$root.filterData.keyword.time) ? $scope.$root.filterData.keyword.time : '');
                    $scope.data.fromdate = $scope.data.date == '' ? undefined : $filter('date')($scope.data.date.split(',')[0], 'yyyy-MM-dd');;
                    $scope.data.untildate = $scope.data.date == '' ? undefined : $filter('date')($scope.data.date.split(',')[1], 'yyyy-MM-dd');;
                    var menuscriptType = $scope.$root.filterData.keyword.menuscriptType;
                    if (menuscriptType == '') { //设置稿件类型
                        $scope.data.docTypeSelected = $scope.data.docType[0];
                    } else {
                        $scope.data.docTypeSelected = menuscriptType == '0' ? $scope.data.docType[0] : (menuscriptType == '1' ? $scope.data.docType[1] : $scope.data.docType[2]);
                    }
                    $scope.params.keyword = $scope.$root.filterData.keyword;
                    $scope.$root.filterData.keyword = {
                        'title': $scope.data.filterTypeSelected.value == '0' ? $scope.params.keyword.keywords : ($scope.data.filterTypeSelected.value == '1' ? $scope.params.keyword.keywords : ''),
                        'content': $scope.data.filterTypeSelected.value == '0' ? $scope.params.keyword.keywords : ($scope.data.filterTypeSelected.value == '2' ? $scope.params.keyword.keywords : ''),
                    };
                    $scope.$root.backFilterData = { //存储返回时信息
                        page: angular.copy($scope.page),
                        keyword: angular.copy($scope.$root.filterData.keyword),
                    };
                    requestData();
                    // }, 0);
                } else {
                    requestData();
                }
                $scope.$on("$destroy", function() {
                    delete $scope.$root.filterData;
                });
            }
            /**
             * [listenStorage description]监听本地缓存
             * @return {[promise]} [description] promise
             */
            function listenStorage() {
                storageListenerService.listenResource(function() {
                    requestData();
                    storageListenerService.removeListener("resource");
                }, $scope);
            }
            /**
             * [requestData description] 请求数据
             * @return {[type]} [description]
             */
            function requestData() {
                var params = angular.copy($scope.params);
                params.keyword = JSON.stringify(params.keyword);
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                    $scope.data.items = data.content;
                    $scope.data.indexName = data.summary_info.indexName;
                    if ($state.params.guid) {
                        showDetail({ ZB_GUID: $state.params.guid });
                    } else if ($scope.data.items.length > 0) { //默认显示第一篇详情
                        showDetail($scope.data.items[0]);
                    }
                    $scope.page.ITEMCOUNT = data.summary_info.ITEMCOUNT;
                    $scope.page.PAGECOUNT = data.summary_info.PAGECOUNT;
                    storageListenerService.previewPageTurningStorage($scope.data.items, "ZB_GUID", "toutiaoDetail");
                    initOperFlag();
                    //存储返回的检索信息
                    $scope.params.keyword.title = $scope.data.filterTypeSelected.value == '0' ? $scope.params.keyword.keywords : ($scope.data.filterTypeSelected.value == '1' ? $scope.params.keyword.keywords : '');
                    $scope.params.keyword.content = $scope.data.filterTypeSelected.value == '0' ? $scope.params.keyword.keywords : ($scope.data.filterTypeSelected.value == '2' ? $scope.params.keyword.keywords : '');
                    $scope.$root.backFilterData = {
                        page: $scope.page,
                        keyword: $scope.params.keyword,
                        filterSelected: $scope.data.filterTypeSelected
                    };
                });
            }

            /**
             * [searchWithKeyword description] 根据条件筛选稿件
             * @param  {[type]} key   [description] 筛选类型
             * @param  {[type]} value [description] 筛选内容
             * @return {[type]}       [description]
             */
            $scope.searchWithKeyword = function(key, value) {
                if (key == "time") {
                    value = $filter('date')($scope.data.fromdate, 'yyyy/MM/dd').toString() ? $filter('date')($scope.data.fromdate, 'yyyy/MM/dd').toString() + "," + $filter('date')($scope.data.untildate, 'yyyy/MM/dd').toString() : "";
                }
                $scope.params.keyword[key] = value;
                if (key == "menuscriptType") {
                    $scope.params.keyword.menuscriptType = value.value;
                }
                $scope.params.pageNum = $scope.page.CURRPAGE = 1;
                $scope.data.items = [];
                if ($scope.data.filterTypeSelected.value == "1") {
                    $scope.params.keyword.title = $scope.params.keyword.keywords;
                    $scope.params.keyword.content = "";
                } else if ($scope.data.filterTypeSelected.value == "2") {
                    $scope.params.keyword.title = "";
                    $scope.params.keyword.content = $scope.params.keyword.keywords;
                } else {
                    $scope.params.keyword.title = $scope.params.keyword.keywords;
                    $scope.params.keyword.content = $scope.params.keyword.keywords;
                }
                delete $state.params.guid;
                requestData();
            };
            /**
             * [initOperFlag description] 初始化取签见撤重
             */
            function initOperFlag() {
                var docIds = trsspliceString.spliceString($scope.data.items, "ZB_GUID", ",");
                if (docIds) {
                    var params = {
                        methodname: "queryFlag",
                        serviceid: "mlf_bigdataexchange",
                        guids: docIds
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function(data) {
                        $scope.data.operFlags = [];
                        var temp = data;
                        for (var i in temp) {
                            if (angular.isDefined(data[i]) && data[i].OPERFLAG.indexOf("1") > -1) {
                                $scope.data.operFlags = $scope.data.operFlags.concat(data[i]);
                            }
                        }
                    });
                }
            }
            /**
             * [showOperFlag description] 显示取签见撤重标志
             * @param  {[type]} guid      [description]
             * @param  {[type]} flagIndex [description]
             * @return {[type]}           [description]
             */
            $scope.showOperFlag = function(guid, flagIndex) {
                var temp = queryItemBYGUID(guid);
                if (!!temp) {
                    return queryItemBYGUID(guid).OPERFLAG.substr(flagIndex, 1) == "1" ? true : false;
                } else {
                    return false;
                }
            };

            /**
             * [queryItemBYGUID description] 根据guid获取在WCM内的取签见撤重的二进制数
             * @param  {[type]} guid [description]
             * @return {[type]}      [description]
             */
            function queryItemBYGUID(guid) {
                for (var i in $scope.data.operFlags) {
                    if (guid == $scope.data.operFlags[i].GUID) {
                        return $scope.data.operFlags[i];
                    }
                }
            }

            /**
             * @param  {[type]} ChnlDocId  [description] 取签见撤重 点击弹出
             * @param  {[type]} showRepeat [description]
             * @return {[type]}            [description]
             */
            $scope.viewBigDataInfo = function(ChnlDocId, showRepeat, showClick, $event) {
                var operFlags = queryItemBYGUID(ChnlDocId).OPERFLAG;
                var infoModal = resCtrModalService.bigDataInfoModal(ChnlDocId, showRepeat, showClick, operFlags);
                event.stopPropagation();
            };
            /**
             * [showTitle description] 鼠标移上去后的标题显示
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            /*$scope.showTitle = function(item) {
                var title = item.DOCTITLE.replace(/\<\/?font(.*?)\>/g, "");
                return title;
            };*/
            /**
             * [showTime description] 调整时间的显示格式
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            $scope.showTime = function(item) {
                var date = new Date(Date.parse(item.LASTTIME));
                return $filter("date")(date, "yyyy-MM-dd HH:mm").toString();
            };
            /**
             * [fullTextSearch description;全文检索]
             * @param  {[type]} ev [description:按下回车也能提交]
             */
            $scope.fullTextSearch = function(ev) {
                if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                    if ($scope.data.filterTypeSelected.value == "1") {
                        $scope.params.keyword.title = $scope.params.keyword.keywords;
                        $scope.params.keyword.content = "";
                    } else if ($scope.data.filterTypeSelected.value == "2") {
                        $scope.params.keyword.title = "";
                        $scope.params.keyword.content = $scope.params.keyword.keywords;
                    } else {
                        $scope.params.keyword.title = $scope.params.keyword.keywords;
                        $scope.params.keyword.content = $scope.params.keyword.keywords;
                    }
                    $scope.page.CURRPAGE = 1;
                    $scope.params.page = $scope.page.CURRPAGE;
                    delete $state.params.guid;
                    requestData();
                }
            };
            /**
             * [getFilterTimeVal description]检索下拉框回调
             * @return {[type]} [description]
             */
            $scope.getFilterVal = function() {
                $scope.params.keyword.searchType = $scope.data.filterTypeSelected.value;
                $scope.$root.backFilterData.filterSelected = $scope.data.filterTypeSelected;
                if ($scope.data.filterTypeSelected.value == '0') {
                    $scope.$root.backFilterData.keyword.content = $scope.$root.backFilterData.keyword.title = $scope.$root.backFilterData.keyword.keywords = $scope.params.keyword.keywords;
                } else if ($scope.data.filterTypeSelected.value == '1') {
                    $scope.$root.backFilterData.keyword.title = $scope.$root.backFilterData.keyword.keywords = $scope.params.keyword.keywords;
                    $scope.$root.backFilterData.keyword.content = '';
                } else {
                    $scope.$root.backFilterData.keyword.content = $scope.$root.backFilterData.keyword.keywords = $scope.params.keyword.keywords;
                    $scope.$root.backFilterData.keyword.title = '';
                }
                $scope.$root.backFilterData.keyword.searchType = $scope.data.filterTypeSelected.value;
            };
            /**
             * [isShowSearch description]显示隐藏检索条件
             * @return {Boolean} [description]
             */
            $scope.isShowSearch = function() {
                $scope.status.searchShow = !$scope.status.searchShow;
            };
            /**
             * [pageChanged description] 分页
             * @return {[type]} [description]
             */
            $scope.pageChanged = function() {
                $scope.params.pageNum = $scope.page.CURRPAGE;
                $scope.jumpToPageNum = $scope.page.CURRPAGE;
                delete $state.params.guid;
                requestData();
            };
            /**
             * [showDetail description]展示详情
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            $scope.showDetail = function(item) {
                showDetail(item);
            };
            /**
             * [showDetail description]展示详情 
             * @param  {[type]} item [description]
             * @return {[type]fvz}      [description]
             */
            function showDetail(item) {
                $scope.status.showRightDetail = false;
                $state.params.guid = item.ZB_GUID;
                $state.go($state.current.name, $state.params, { reload: false });
                $scope.data.rebuildData = {
                    guid: item.ZB_GUID,
                };
                $timeout(function() {
                    $scope.status.curSelected = item.ZB_GUID;
                    $scope.status.showRightDetail = true;
                }, 0);
            }
            /**
             * [plainView description] 返回 普通视图
             * @return {[type]} [description]
             */
            $scope.plainView = function() {
                $scope.params.keyword.title = $scope.data.filterTypeSelected.value == '0' ? $scope.params.keyword.keywords : ($scope.data.filterTypeSelected.value == '1' ? $scope.params.keyword.keywords : '');
                $scope.params.keyword.content = $scope.data.filterTypeSelected.value == '0' ? $scope.params.keyword.keywords : ($scope.data.filterTypeSelected.value == '2' ? $scope.params.keyword.keywords : '')
                $scope.$root.backFilterData = {
                    page: $scope.page, //分页
                    keyword: $scope.params.keyword, //检索词
                    filterSelected: $scope.data.filterTypeSelected
                };
                $state.go("front.networksource.featuredresource.toutiao.resource", $stateParams);
            };
        }
    ]);